// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YFGl","content":"styles_content__1-6cS","tableWrap":"styles_tableWrap__sgYjk"};